import { ColumnConfig } from '@app/shared/custom-component/grid-actions/grid-actions.component';

/** Map data-grid customHeaders to app-grid-actions column config (data columns only). */
export function headersToColumnConfigs(headers: any[] | undefined | null): ColumnConfig[] {
  if (!Array.isArray(headers)) return [];
  return headers
    .filter(h => h?.dataField != null && String(h.dataField).trim() !== '')
    .map(h => ({
      key: String(h.dataField),
      label: String(h.caption ?? h.dataField ?? ''),
      disabled: h.allowHiding === false
    }));
}

/** Preserve user toggles for existing keys; default new keys to visible (true). */
export function mergeVisibleColumnDefaults(
  columnKeys: string[],
  previous: Record<string, boolean> | null | undefined
): Record<string, boolean> {
  const next: Record<string, boolean> = {};
  for (const key of columnKeys) {
    const prevVal = previous?.[key];
    next[key] = prevVal === undefined ? true : !!prevVal;
  }
  return next;
}

/** Prefer `application_id` (case-insensitive); else first column key so one column always stays visible. */
export function columnChooserLockKey(columnKeys: string[]): string | undefined {
  if (!columnKeys.length) return undefined;
  const app = columnKeys.find(k => k.toLowerCase() === 'application_id');
  return app ?? columnKeys[0];
}

/** Mark the lock column non-hideable in the column chooser (Queues background pattern). */
export function withColumnChooserLock(configs: ColumnConfig[]): ColumnConfig[] {
  const lockKey = columnChooserLockKey(configs.map(c => c.key));
  if (lockKey == null) return configs;
  return configs.map(col => ({
    ...col,
    disabled: !!(col.disabled || col.key === lockKey)
  }));
}

/** Like mergeVisibleColumnDefaults, but the lock key is always visible (cannot be fully hidden via persisted state). */
export function mergeVisibleColumnDefaultsWithChooserLock(
  columnKeys: string[],
  previous: Record<string, boolean> | null | undefined
): Record<string, boolean> {
  const merged = mergeVisibleColumnDefaults(columnKeys, previous);
  const lock = columnChooserLockKey(columnKeys);
  if (lock) merged[lock] = true;
  return merged;
}

/** Build export column list honoring visibleColumns (false = hidden). */
export function columnsForExcelExport(
  headers: any[] | undefined | null,
  visibleColumns: Record<string, boolean> | null | undefined
): { label: string; key: string; dataType?: string }[] {
  return (headers || [])
    .filter(h => h?.dataField && visibleColumns?.[h.dataField] !== false)
    .map(h => ({ label: h.caption, key: h.dataField, dataType: h.dataType }));
}
